import React, { Component } from "react";
import { Link } from "react-router-dom";
import Banner from "../../components/common/Banner";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import { firestore } from "../../Config/FbConfig";
import { doc, onSnapshot, collection } from "firebase/firestore";

export default class TeachingAndLearning extends Component {
  state = {
    // Notifications
    Title: "Notifications",
    Doc: "Notificationss",
    Collection: "Home",
    Path: "Notifications / ",

    // Academic Rules
    AcademicRulesDoc: "AcademicRules",
    AcademicRulesData: ["Loading"],

    // Scheme And Syllabus
    SchemeAndSyllabusDoc: "SchemeAndSyllabus",
    SchemeAndSyllabusData: ["Loading"],

    // Results
    ResultsDoc: "Results",
    ResultsData: ["Loading"],

    DescriptionCount: 200,
    VideoCount: 200,

    DescriptionValid: false,
    VideoValid: false,

    Data: ["Loading"],
    OpenModal: false,
    ModalType: "ADD",
    UpdateId: null,
  };

  componentDidMount() {
    // Notifications fetch
    const docRef = doc(
      collection(firestore, this.state.Collection),
      this.state.Doc
    );
    this.unsubscribeNotifications = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const Data = [];
        Object.entries(docSnap.data()).forEach(([key, value]) => {
          Data.push(
            Object.assign({ Id: key }, value, {
              FilterData: JSON.stringify(value),
            })
          );
        });
        this.setState({
          Data: Data,
        });
      } else {
        this.setState({
          Data: [],
        });
      }
    });

    // Academic Rules fetch
    const academicRulesRef = doc(
      collection(firestore, this.state.Collection),
      this.state.AcademicRulesDoc
    );
    this.unsubscribeAcademicRules = onSnapshot(academicRulesRef, (docSnap) => {
      if (docSnap.exists()) {
        const Data = [];
        Object.entries(docSnap.data()).forEach(([key, value]) => {
          Data.push(
            Object.assign({ Id: key }, value, {
              FilterData: JSON.stringify(value),
            })
          );
        });
        this.setState({
          AcademicRulesData: Data,
        });
      } else {
        this.setState({
          AcademicRulesData: [],
        });
      }
    });

    // Scheme And Syllabus fetch
    const schemeRef = doc(
      collection(firestore, this.state.Collection),
      this.state.SchemeAndSyllabusDoc
    );
    this.unsubscribeScheme = onSnapshot(schemeRef, (docSnap) => {
      if (docSnap.exists()) {
        const Data = [];
        Object.entries(docSnap.data()).forEach(([key, value]) => {
          Data.push(
            Object.assign({ Id: key }, value, {
              FilterData: JSON.stringify(value),
            })
          );
        });
        this.setState({
          SchemeAndSyllabusData: Data,
        });
      } else {
        this.setState({
          SchemeAndSyllabusData: [],
        });
      }
    });

    // Results fetch
    const resultsRef = doc(
      collection(firestore, this.state.Collection),
      this.state.ResultsDoc
    );
    this.unsubscribeResults = onSnapshot(resultsRef, (docSnap) => {
      if (docSnap.exists()) {
        const Data = [];
        Object.entries(docSnap.data()).forEach(([key, value]) => {
          Data.push(
            Object.assign({ Id: key }, value, {
              FilterData: JSON.stringify(value),
            })
          );
        });
        this.setState({
          ResultsData: Data,
        });
      } else {
        this.setState({
          ResultsData: [],
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribeNotifications) this.unsubscribeNotifications();
    if (this.unsubscribeAcademicRules) this.unsubscribeAcademicRules();
    if (this.unsubscribeScheme) this.unsubscribeScheme();
    if (this.unsubscribeResults) this.unsubscribeResults();
  }

  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Autonomous" image="banners/banner-teaching.jpg" />

        <div className="container-xl" style={{ paddingTop: "4rem" }}>
          <div className="ttm-service-description">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="title-header paddingtop-1"
                  style={{ borderTopColor: "red", textAlign: "center" }}
                >
                  <h4 className="title">
                    Controller of Examinations – Bangalore Institute of
                    Technology (BIT)
                  </h4>
                </div>
              </div>

              {/* <div className="col-md-6 paddingtop-2">
                <div
                  className="ttm_single_image-wrapper"
                  style={{ display: "flex", justifyContent: "end" }}
                >
                  <img
                    className="img-fluid"
                    src={
                      process.env.PUBLIC_URL + "/assets/images/t-l/Picture1.png"
                    }
                    title="single-img-twenty"
                    alt="single-img-twenty"
                    style={{ height: "300px", width: "50%" }}
                  />
                </div>
              </div>
              <div
                className="col-md-6 paddingtop-2"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div className="ttm_single_image-wrapper">
                  <h6>Dr. Sreerama Reddy T V</h6>
                  <p className="paddingtop-1">
                    Controller of Examinations (COE)
                  </p>
                  <p className="paddingtop-1">Professor</p>
                  <p className="paddingtop-1">
                    Department of Mechanical Engineering
                  </p>
                </div>
              </div> */}
              <div
                className="col-md-6 paddingtop-2"
                style={{ marginTop: "2rem" }}
              >
                <div
                  className="ttm_single_image-wrapper"
                  style={{ display: "flex", justifyContent: "end" }}
                >
                  <img
                    className="img-fluid"
                    src={
                      process.env.PUBLIC_URL + "/assets/images/t-l/Picture2.png"
                    }
                    title="single-img-twenty"
                    alt="single-img-twenty"
                    style={{ height: "300px", width: "50%" }}
                  />
                </div>
              </div>
              <div
                className="col-md-6 paddingtop-2"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div className="ttm_single_image-wrapper">
                  <h6>Dr. Asha.T</h6>
                  <p className="paddingtop-1">
                    Controller of Examinations (COE)
                  </p>
                  <p className="paddingtop-1">Professor and Head</p>
                  <p className="paddingtop-1">ISE Department</p>
                </div>
              </div>

              <div
                className="col-12 justify paddingtop-2"
                style={{ margin: "auto" }}
              >
                <div className="section-title with-desc text-left clearfix">
                  <div
                    className="title-header paddingtop-2"
                    style={{ borderTopColor: "red" }}
                  >
                    <h4 className="title">
                      Autonomous Status of BIT under VTU Affiliation
                    </h4>
                  </div>
                </div>
                <p className="justify">
                  Bangalore Institute of Technology (BIT) has been granted
                  autonomous status under the affiliation of Visvesvaraya
                  Technological University (VTU) starting from the academic year
                  2024–25. This significant milestone empowers the institution
                  with academic freedom to design its own curriculum, evaluation
                  methods, and academic regulations while continuing to be
                  affiliated with VTU for degree awarding. Autonomy enables BIT
                  to introduce industry-relevant courses, promote innovation in
                  teaching and learning, and respond swiftly to technological
                  advancements—ultimately enhancing the quality of education and
                  student outcomes. This change marks a new era of academic
                  excellence, flexibility, and institutional growth.
                </p>
                <p className="paddingtop-2">
                  The Examination Section at Bangalore Institute of Technology
                  is a vital academic support unit, headed by the Controller of
                  Examinations (COE), responsible for the transparent,
                  efficient, and smooth conduct of examinations across all
                  departments. The COE’s office operates in alignment with the
                  academic calendar to ensure timely execution of Continuous
                  Internal Evaluation (CIE), Semester End Examinations (SEE),
                  and other related evaluation processes
                </p>
              </div>
              <div>
                <h4 className="title paddingtop-2">
                  The core responsibilities of the COE and the Examination Cell
                  include
                </h4>
                <div className="paddingtop-2">
                  <ul className="ttm-list ttm-list-style-icon 2">
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Planning, scheduling, and conducting all internal and
                        end-semester examinations.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Ensuring the preparation, confidentiality, printing, and
                        distribution of question papers.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Supervising the secure collection and digital evaluation
                        of answer scripts.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Coordinating the collection and tabulation of internal
                        assessment marks from all departments.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Publishing examination results, issuing grade cards,
                        transcripts, and Provisional Degree Certificates (PDC).
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Conducting revaluation, paper viewing, and addressing
                        grievances related to examination results.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Ensuring adherence to regulations laid down by the
                        affiliating university (VTU), UGC, and other statutory
                        bodies.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Organizing orientation and awareness programs on
                        examination protocols for faculty and students.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Implementing automated systems to streamline processes,
                        ensure data integrity, and improve accessibility for all
                        stakeholders.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Maintaining the highest level of confidentiality and
                        integrity in all matters related to examinations.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Coordinating with academic deans and department heads to
                        ensure effective communication and implementation of
                        academic policies.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Facilitating preparation of rank lists, award of medals,
                        and certificates for convocation ceremonies.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Conducting malpractice inquiry meetings and issuing
                        related notifications as per institutional policy.
                      </span>
                    </li>
                  </ul>
                  <div className="paddingtop-1">
                    <p>
                      The COE’s office is committed to continuous improvement
                      and embraces technology to enhance operational efficiency
                      while ensuring a student-centric approach that upholds
                      fairness and academic integrity.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          {/* Notifications Table */}
          <div className="paddingtop-2">
            <h4 style={{ paddingBottom: "1rem" }} className="title">
              Notifications
            </h4>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Link</th>
                </tr>
              </thead>
              <tbody>
                {this.state.Data &&
                this.state.Data[0] !== "Loading" &&
                this.state.Data.length > 0 ? (
                  this.state.Data.map((item) => (
                    <tr key={item.Id}>
                      <td>{item.Description || "-"}</td>
                      <td>
                        {item.Description ? (
                          <a
                            href={item.Video}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No notifications found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Academic Rules Table */}
          <div className="paddingtop-2">
            <h4 style={{ paddingBottom: "1rem" }} className="title">
              Academic Rules And Regulations
            </h4>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Link</th>
                </tr>
              </thead>
              <tbody>
                {this.state.AcademicRulesData &&
                this.state.AcademicRulesData[0] !== "Loading" &&
                this.state.AcademicRulesData.length > 0 ? (
                  this.state.AcademicRulesData.map((item) => (
                    <tr key={item.Id}>
                      <td>{item.Description || "-"}</td>
                      <td>
                        {item.Description ? (
                          <a
                            href={item.Video}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No academic rules found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Scheme And Syllabus Table */}
          <div className="paddingtop-2">
            <h4 style={{ paddingBottom: "1rem" }} className="title">
              Scheme And Syllabus
            </h4>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Link</th>
                </tr>
              </thead>
              <tbody>
                {this.state.SchemeAndSyllabusData &&
                this.state.SchemeAndSyllabusData[0] !== "Loading" &&
                this.state.SchemeAndSyllabusData.length > 0 ? (
                  this.state.SchemeAndSyllabusData.map((item) => (
                    <tr key={item.Id}>
                      <td>{item.Description || "-"}</td>
                      <td>
                        {item.Description ? (
                          <a
                            href={item.Video}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No scheme and syllabus found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Results Table */}
          <div className="paddingtop-2">
            <h4 style={{ paddingBottom: "1rem" }} className="title">
              Results
            </h4>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Link</th>
                </tr>
              </thead>
              <tbody>
                {this.state.ResultsData &&
                this.state.ResultsData[0] !== "Loading" &&
                this.state.ResultsData.length > 0 ? (
                  this.state.ResultsData.map((item) => (
                    <tr key={item.Id}>
                      <td>{item.Description || "-"}</td>
                      <td>
                        {item.Description ? (
                          <a
                            href={item.Video}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No results found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
